import { useEffect } from 'react';
import { ACTION_BAR_IDS } from '../../constants/actionBar';

export const useActionBarSelectHack = () => {
  useEffect(() => {
    const path = location.pathname.substring(1);

    if (ACTION_BAR_IDS.includes(path)) {
      document.getElementById(path).click();
    }
  }, []); //barf
};
